import { createSlice } from "@reduxjs/toolkit";

const initialState = {
      linkedMeetings: null,
      linkedMeetingSelected: null

};

const linkedMeetingsSlice = createSlice(
      {
            name: "linkedMeetings",
            initialState,
            reducers: {
                  setlinkedMeetings: (state, action) => {
                        state.linkedMeetings = action.payload;
                  },
                  setlinkedMeetingsLogout: (state, action) => {
                        state.linkedMeetings = null;
                  },
                  setlinkedMeetingSelected: (state, action) => {
                        state.linkedMeetingSelected = action.payload;
                  },
                  setlinkedMeetingSelectedLogout: (state, action) => {
                        state.linkedMeetingSelected = null
                  }
            },
      },
);


export const { setlinkedMeetings, setlinkedMeetingsLogout, setlinkedMeetingSelected, setlinkedMeetingSelectedLogout } = linkedMeetingsSlice.actions;

export default linkedMeetingsSlice.reducer;
